import React from 'react';

const Content = ({ children }: React.PropsWithChildren) => <div className="content">{children}</div>;

export default Content;
